/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiOutlineCheckCircle, AiOutlineMinusCircle } from "react-icons/ai";
import { BiLinkExternal, BiUserPlus } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../assets/images/svgs/edit.svg";
import DataTable from "../../../../components/dataTable/dataTable";
import AddNewAgentModal from "../../../../components/modals/AddNewAgentModal";
import ProductModal from "../../../../components/modals/ProductModal";
import { getPartnerAgentBranch } from "../../../../store/actions/agent.action";
import { agentTableConfig } from "../../../../utils/helpers/dataTableConfigs";
import { AgentService } from "../../../../utils/services/agent.service";

function Body({ domainBrand, partnerAgent = [], size, countries }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [filterInput, setFilterInput] = useState("");
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [kyc, setKyc] = useState("");
  const [role, setRole] = useState("");
  const [title, setTitle] = useState("");

  const actionColumn = {
    Header: () => {
      return <span className="text-center">Action</span>;
    },
    columnId: 5,
    accessor: "actions",
    Cell: ({ row }) => {
      const status = row.original.status;
      const paycenterId = row.original.id;
      return (
        <div className="text-start pointer">
          <OverlayTrigger
            key={"1"}
            placement={"bottom"}
            overlay={
              <Tooltip id={`tooltip-${``}`}>
                {status === "ACTIVATED" ? "Deactivate" : "Activate"}
              </Tooltip>
            }
          >
            {status !== "ACTIVATED" ? (
              <AiOutlineCheckCircle
                fontSize={18}
                color={"#6259CA"}
                onClick={() => {
                  setShow(true);
                  setId(row?.original?.agentId);
                  setType("ACTIVATE");
                  setKyc(row?.original?.parentPayCenterName);
                }}
              />
            ) : (
              <AiOutlineMinusCircle
                fontSize={18}
                color={"#6259CA"}
                onClick={() => {
                  setShow(true);
                  setId(row?.original?.agentId);
                  setType("DEACTIVATE");
                  setKyc(row?.original?.parentPayCenterName);
                }}
              />
            )}
          </OverlayTrigger>
          &nbsp; &nbsp;
          <OverlayTrigger
            key={"2"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Edit</Tooltip>}
          >
            <Edit fontSize={22} color={"#6259CA"} />
          </OverlayTrigger>
          &nbsp; &nbsp;
          <OverlayTrigger
            key={"3"}
            placement={"bottom"}
            overlay={
              <Tooltip id={`tooltip-${``}`}>Link to Administrators</Tooltip>
            }
          >
            {/* < to={"/management/administrators"} className="cursor-pointer"> */}
            <BiLinkExternal
              fontSize={18}
              color={"#6259CA"}
              onClick={() =>
                history.push({
                  pathname: `/management/administrators/${paycenterId}`,
                  state: { id: paycenterId },
                })
              }
            />
          </OverlayTrigger>
          &nbsp; &nbsp;
          <OverlayTrigger
            key={"4"}
            placement={"bottom"}
            overlay={
              <Tooltip id={`tooltip-${``}`}>Add new Administrator</Tooltip>
            }
          >
            <BiUserPlus fontSize={22} color={"#6259CA"} />
          </OverlayTrigger>
        </div>
      );
    },
  };

  const tableObject = [...agentTableConfig, actionColumn];
  const columns = useMemo(() => tableObject, []);

  const handleActivation = async (id) => {
    setLoading(true);
    try {
      const response = await AgentService.approveAgentById(id);

      if (response.status === "SUCCESS") {
        toast.success("partner activated successfully");
        dispatch(getPartnerAgentBranch());
        setLoading(false);
        setShow(false);
      } else {
        toast.error(response.message);
        setLoading(false);
        setShow(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const handleDeactivation = async (id) => {
    setLoading(true);
    try {
      const response = await AgentService.disapproveAgentById(id);
      if (response.status === "SUCCESS") {
        toast.success("partner deactivated successfully");
        dispatch(getPartnerAgentBranch());
        setLoading(false);
        setShow(false);
      } else {
        toast.error(response.message);
        setLoading(false);
        setShow(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <ProductModal
        show={show}
        handleClose={() => {
          setShow(false);
          setLoading(false);
        }}
        type={type}
        handleActivation={() => handleActivation(id)}
        handleDeactivation={() => handleDeactivation(id)}
        loading={loading}
        prodName={kyc}
      />
      <AddNewAgentModal
        show={open}
        handleClose={() => {
          setOpen(false);
          setLoading(false);
        }}
        domainBrand={domainBrand}
        countries={countries}
        type={role}
        title={title}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary ? dictionary["PAY_CENTRE_183647889"] : "Agent"}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {dictionary
                    ? dictionary[
                        "para_pay_center_can_be_either_a_bank_or_agent"
                      ]
                    : `Agent can be either a bank, bank branch and Agent. Here you can
                create branches for the registered bank which can be used as an
                agent.`}
                </li>
              </ol>
            </div>
          </div>
          <div className="ms-auto pageheader-btn" />
          <div className="row row-sm">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  {/* <h3 className="card-title">
                  Agent can be either a bank, bank branch and Agent. Here you
                  can create branches for the registered bank which can be used
                  as an agent.
                </h3> */}
                </div>
                <div className="card-body">
                  <div className="form-row mb-5 pb-5">
                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary w-100 fw-bold mb-2"
                        type="button"
                        onClick={() => {
                          setOpen(true);
                          setTitle("Register Agent/Branch");
                        }}
                      >
                        +NEW AGENT (CASH PICK-UP, BUREAU DE CHANGE)
                      </button>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary w-100 fw-bold mb-2"
                        type="button"
                        onClick={() => {
                          setOpen(true);
                          setTitle("Register Agent/Branch");
                        }}
                      >
                        +NEW MERCHANT
                      </button>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary w-100 fw-bold mb-2"
                        type="button"
                        onClick={() =>
                          history.push("/plugins/payout-api/add-payout-api")
                        }
                      >
                        +NEW API(BANK TRANSFER, AIRTIME, BILL PAYMENT, MOBILE
                        MONEY)
                      </button>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary w-100 fw-bold mb-2"
                        type="button"
                        onClick={() => {
                          setOpen(true);
                          setTitle("Register Agent/Branch");
                        }}
                      >
                        +PAYMENT COLLECTION POINT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card custom-card">
                <div className="col-md-6 col-lg-6 mt-2">
                  <label className="mb-1">Filter</label>
                  <input
                    type={"text"}
                    className="form-control border px-3"
                    placeholder="Search..."
                    autoComplete=""
                    value={filterInput}
                    onChange={(e) => setFilterInput(e.target.value)}
                  />
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <DataTable
                      columns={columns}
                      data={partnerAgent}
                      filterData={filterInput}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Body;
